
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getOrderScheduledDate, getOrderDelivery, formatCustomQuestionAnswer } from '@/utils/getters';
import { formatPhoneNumberForDisplay } from '@/utils/format';
import { decodeOrder, decodeString } from '@/utils/decoding';

@Component<OrderInfo>({})
export default class OrderInfo extends Vue {
	@Prop({ type: Object, required: true }) private order!: Order;
	@Prop({ type: String, required: false }) private orderPaymentPreference!: string;

	private mutableOrder: Order = this.order;

	private get cancellationNote(): string | undefined {
		return this.mutableOrder.cancellation_note ? decodeString(this.mutableOrder.cancellation_note) : undefined;
	}

	private get orderUserName(): string | undefined {
		return this.mutableOrder.data.checkout?.contact?.full_name;
	}

	private get scheduledDate(): string | undefined {
		return getOrderScheduledDate(this.mutableOrder);
	}

	private get orderUserPhone(): string | undefined {
		return formatPhoneNumberForDisplay(this.mutableOrder.data.checkout?.contact?.phone_number) || undefined;
	}

	private get orderUserEmail(): string | undefined {
		return this.mutableOrder.data.checkout?.contact?.email || undefined;
	}

	private get orderDelivery(): string | undefined {
		return getOrderDelivery(this.mutableOrder);
	}

	private get orderCustomQuestions(): AnsweredCustomQuestion[] | undefined {
		if (this.mutableOrder.data.checkout?.questions?.length) {
			return this.mutableOrder.data.checkout.questions;
		}
	}

	private get orderInstructions(): string | undefined {
		return this.mutableOrder.data.checkout?.pickup?.notes || undefined;
	}

	private mounted(): void {
		this.mutableOrder = decodeOrder(this.mutableOrder) as Order;
	}

	/**
	 * Formats the answer of a custom question.
	 *
	 * @param {AnsweredCustomQuestion} answeredQuestion
	 * @return {string}
	 */
	private formatCustomQuestionAnswer(answeredQuestion: AnsweredCustomQuestion): string {
		return formatCustomQuestionAnswer(answeredQuestion);
	}
}
